module.exports = __webpack_public_path__ + "static/media/PR.b3c9d75b.svg";